
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.745 9.591A5.263 5.263 0 007.973 8H6.332A5.262 5.262 0 002.56 9.591 5.38 5.38 0 001 13.387c0 .226.184.41.41.41h11.485a.41.41 0 00.41-.41 5.38 5.38 0 00-1.56-3.796zM6.691 0A3.696 3.696 0 003 3.691a3.696 3.696 0 003.691 3.692 3.696 3.696 0 003.692-3.692A3.696 3.696 0 006.69 0z"}})])
          )
        }
      }
    